import PropTypes from 'prop-types';
import { useCallback, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import ReturnLinkHelper from '../utils/ReturnLinkHelper';
import productFromUrl from '../utils/productFromUrl';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import { LeftIcon } from 'foundations-assets';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledLink = styled.span.withConfig({
  displayName: "BackLink__StyledLink",
  componentId: "sc-1ctnmpd-0"
})(({
  theme
}) => ({
  display: 'inline-block',
  marginInlineStart: `-${theme.space['800']}`,
  marginBlockEnd: theme.space['700'],
  paddingBlock: theme.space['200'],
  paddingInline: theme.space['300'],
  borderWidth: `${theme.borderWidth['100']} ${theme.borderWidth['100']} ${theme.borderWidth['100']} ${theme.borderWidth['0']}`,
  borderStyle: 'solid',
  borderRadius: `${theme.borderRadius['0']} ${theme.borderRadius['100']} ${theme.borderRadius['100']} ${theme.borderRadius['0']}`,
  borderColor: theme.color['border-core-hover'],
  '&:hover': {
    color: theme.color['text-core-hover']
  }
}));
const BackLink = ({
  onClick,
  isDevPortal
}) => {
  const portalId = PortalIdParser.get();
  const eschref = ReturnLinkHelper.get();
  const getFallbackLink = () => isDevPortal ? `/developer/${portalId}` : `/dashboard/${portalId}`;
  const href = eschref || getFallbackLink();
  const escProduct = useMemo(() => {
    return eschref ? productFromUrl(eschref) : undefined;
  }, [eschref]);
  let backLangKey = 'settings-ui-nav.dashboard';
  if (escProduct) {
    backLangKey = escProduct.langKey;
  } else if (eschref) {
    backLangKey = 'settings-ui-nav.back';
  } else if (href === `/developer/${portalId}`) {
    backLangKey = 'settings-ui-nav.home';
  }
  const handleClick = useCallback(() => {
    ReturnLinkHelper.clear();
    onClick(href);
  }, [onClick, href]);
  return /*#__PURE__*/_jsx(StyledLink, {
    children: /*#__PURE__*/_jsx(Link, {
      use: "unstyled",
      onClick: handleClick,
      href: `${window.location.origin}${href}`,
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        children: [/*#__PURE__*/_jsx(LeftIcon, {
          size: "100",
          color: "icon-core-subtle"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: backLangKey
        })]
      })
    })
  });
};
BackLink.propTypes = {
  onClick: PropTypes.func,
  isDevPortal: PropTypes.bool
};
export default BackLink;